<template>
  <div class="tnm-root">
    <v-app-bar app class="tnm-bar" :class="vm.menu_dialog ? 'app_z_index' : ''" color="#fff">
      <section v-if="!vm.hide_navigation" class="tnm-hamburger" :class="vm.board_bg_cls" @click="vm.open__dialog()">
        <img src="@/assets/Menu/hamburger_icon.svg" width="18" height="16" />
      </section>

      <div class="tnm-logo">
        <img v-if="vm.is_family_book" src="@/assets/familybook_logo.svg" class="tnm-logo-img" />
        <img v-else-if="vm.logoUrl" :src="vm.logoUrl" @error="vm.handleLogoError" class="tnm-logo-img" />
        <img v-else :src="vm.menuLogo_Src" class="tnm-logo-img" />
      </div>

      <v-spacer></v-spacer>

      <v-chip v-if="vm.isTrialSubscription && !vm.is_board_page && !vm.is_family_book" x-small dark
        class="mr-2 font-weight-bold" color="amber darken-3" style="letter-spacing:.5px;font-size:9px">TRIAL</v-chip>

      <div v-if="!vm.is_family_book && !vm.hide_navigation" class="tnm-chat-btn" @click="vm.closeMenuAndGo('/chat_hub')">
        <svg viewBox="0 0 24 24" fill="none" width="17" height="17">
          <path d="M12 3C6.48 3 2 6.58 2 11c0 2.18 1.08 4.15 2.85 5.58L4 21l4.36-1.78c1.13.37 2.36.78 3.64.78 5.52 0 10-3.58 10-8s-4.48-8-10-8z" fill="#fff"/>
          <circle cx="8.5" cy="11" r="1.2" fill="#E91E63"/><circle cx="12" cy="11" r="1.2" fill="#9C27B0"/><circle cx="15.5" cy="11" r="1.2" fill="#3F51B5"/>
        </svg>
        <span v-if="vm.chatUnread > 0" class="tnm-chat-badge">{{ vm.chatUnread > 99 ? '99+' : vm.chatUnread }}</span>
        <span v-else class="tnm-chat-dot"></span>
      </div>

      <button class="tnm-qa-trigger" @click="sheetOpen = true" title="Quick Actions">
        <v-icon size="20" color="#fff">mdi-view-grid-outline</v-icon>
      </button>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <img :src="vm.profileImage" @error="vm.setFallbackImage" v-bind="attrs" v-on="on" class="tnm-profile-img" alt="profile" />
        </template>
        <v-list class="sub_list_txt">
          <v-list-item @click="vm.UpdateProfile()"><v-list-item-title class="sub_list_txt"><v-icon size="20">mdi-account-details</v-icon> My Profile</v-list-item-title></v-list-item>
          <v-list-item v-if="vm.entity__Data.length > 1" @click="vm.Switch_Entities()"><v-list-item-title class="sub_list_txt"><v-icon size="20">mdi-swap-horizontal</v-icon> Entity : {{ vm.entity_name }}</v-list-item-title></v-list-item>
          <v-list-item v-if="vm.setupPct >= 100" @click="vm.closeMenuAndGo('/setup_guide')"><v-list-item-title class="sub_list_txt"><v-icon size="20">mdi-cog-outline</v-icon> Setup Guide</v-list-item-title></v-list-item>
          <v-list-item @click="vm.closeMenuAndGo('/help')"><v-list-item-title class="sub_list_txt"><v-icon size="20">mdi-help-circle-outline</v-icon> Help</v-list-item-title></v-list-item>
          <v-list-item @click="vm.logout()"><v-list-item-title class="sub_list_txt"><v-icon size="20">mdi-logout</v-icon> Logout</v-list-item-title></v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- ═══ Quick Actions bottom sheet — every remaining top-bar action, reachable in one tap ═══ -->
    <transition name="tnm-fade">
      <div v-if="sheetOpen" class="tnm-sheet-backdrop" @click="sheetOpen = false"></div>
    </transition>
    <transition name="tnm-sheet-up">
      <div v-if="sheetOpen" class="tnm-sheet">
        <div class="tnm-sheet-handle"></div>
        <div class="tnm-sheet-header">
          <span>Quick Actions</span>
          <button class="tnm-sheet-close" @click="sheetOpen = false"><v-icon size="18">mdi-close</v-icon></button>
        </div>
        <div class="tnm-sheet-body">

          <div v-if="!vm.is_board_page && !vm.is_family_book && !vm.hide_navigation && vm.setupPct < 100"
            class="tnm-grid-item" @click="act(() => vm.closeMenuAndGo('/setup_guide'))">
            <div class="tnm-grid-ic" style="background:linear-gradient(135deg,#6366F1,#4338CA)">
              <svg viewBox="0 0 36 36" width="20" height="20">
                <circle cx="18" cy="18" r="15.9" fill="none" stroke="rgba(255,255,255,.3)" stroke-width="3.5"/>
                <circle cx="18" cy="18" r="15.9" fill="none" stroke="#fff" stroke-width="3.5" stroke-linecap="round" :stroke-dasharray="vm.setupPct + ' 100'" style="transform:rotate(-90deg);transform-origin:center"/>
              </svg>
            </div>
            <span class="tnm-grid-label">Setup Guide</span>
            <span class="tnm-grid-badge">{{ vm.setupPct }}%</span>
          </div>

          <div v-for="fav in vm.topBarFavourites" :key="'m-qf-' + fav.module_key" class="tnm-grid-item"
            @click="act(() => vm.closeMenuAndGo(fav.module_route))">
            <div class="tnm-grid-ic" :style="{ background: vm.getFavItemColor(fav.module_key, fav.module_category) }">
              <v-icon v-if="vm.hasMeaningfulIcon(fav.module_icon)" color="#fff" size="19">{{ fav.module_icon }}</v-icon>
              <span v-else class="tnm-grid-ic-text">{{ vm.getFavInitials(fav.module_name) }}</span>
            </div>
            <span class="tnm-grid-label">{{ fav.module_name }}</span>
          </div>

          <div v-if="!vm.is_board_page && !vm.is_family_book && !vm.hide_navigation" class="tnm-grid-item-wide">
            <QuickAccessPanel />
          </div>

          <div v-if="!vm.is_board_page && !vm.is_family_book && !vm.hide_navigation" class="tnm-grid-item" @click="act(() => vm.toggleQuickMinutes())">
            <div class="tnm-grid-ic" style="background:linear-gradient(135deg,#E8553A,#1e2b6e)">
              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
            </div>
            <span class="tnm-grid-label">Quick Add Minutes</span>
          </div>

          <div v-if="!vm.is_family_book && !vm.hide_navigation" class="tnm-grid-item" @click="act(() => vm.$router.push('/starr_implementation_programme'))">
            <div class="tnm-grid-ic" style="background:linear-gradient(135deg,#D64B7A,#3B4CC0)">
              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>
            </div>
            <span class="tnm-grid-label">STARR Implementation</span>
          </div>

          <div v-if="vm.entity__Data.length > 1" class="tnm-grid-item" @click="act(() => vm.Switch_Entities())">
            <div class="tnm-grid-ic tnm-grid-ic-plain"><v-icon color="#5A5A72" size="19">mdi-swap-horizontal</v-icon></div>
            <span class="tnm-grid-label">Switch Entity</span>
          </div>

          <div v-if="vm.has_multi_domain" class="tnm-grid-item" @click="act(() => vm.open_switch_company())">
            <div class="tnm-grid-ic tnm-grid-ic-plain"><v-icon color="#5A5A72" size="19">mdi-office-building-outline</v-icon></div>
            <span class="tnm-grid-label">Switch Company</span>
          </div>

          <div v-if="vm.isSingleEntity && vm.hasMultipleHosts" class="tnm-grid-item" @click="hostSheetOpen = true">
            <div class="tnm-grid-ic tnm-grid-ic-plain"><v-icon color="#5A5A72" size="19">mdi-star-settings-outline</v-icon></div>
            <span class="tnm-grid-label">Switch Host</span>
          </div>

          <div v-if="!vm.isfamily_book && vm.is_boardpage" class="tnm-grid-item" @click="act(() => vm.redirect_to_dashboard())">
            <div class="tnm-grid-ic tnm-grid-ic-plain"><v-icon color="#5A5A72" size="19">mdi-view-dashboard</v-icon></div>
            <span class="tnm-grid-label">Dashboard</span>
          </div>
          <div v-if="!vm.isfamily_book && vm.is_boardpage" class="tnm-grid-item" @click="act(() => vm.redirect_to_leader_ship_stucture())">
            <div class="tnm-grid-ic tnm-grid-ic-plain"><v-icon color="#5A5A72" size="19">mdi-family-tree</v-icon></div>
            <span class="tnm-grid-label">Leadership</span>
          </div>
          <div v-if="vm.isfamily_book" class="tnm-grid-item" @click="act(() => vm.redirect_to_family_tree())">
            <div class="tnm-grid-ic tnm-grid-ic-plain"><v-icon color="#5A5A72" size="19">mdi-family-tree</v-icon></div>
            <span class="tnm-grid-label">Family Tree</span>
          </div>
          <div v-if="vm.isfamily_book" class="tnm-grid-item" @click="act(() => vm.redirect_to_family_office())">
            <div class="tnm-grid-ic tnm-grid-ic-plain"><v-icon color="#5A5A72" size="19">mdi-account-group</v-icon></div>
            <span class="tnm-grid-label">Family Office</span>
          </div>
          <div v-if="vm.isfamily_book" class="tnm-grid-item" @click="act(() => vm.redirect_to_family_forum())">
            <div class="tnm-grid-ic tnm-grid-ic-plain"><v-icon color="#5A5A72" size="19">mdi-forum</v-icon></div>
            <span class="tnm-grid-label">Family Forum</span>
          </div>
          <div v-if="vm.isfamily_book" class="tnm-grid-item" @click="act(() => vm.open_chat())">
            <div class="tnm-grid-ic tnm-grid-ic-plain"><img src="@/assets/messages-2.svg" width="19" height="19" /></div>
            <span class="tnm-grid-label">Chat Room</span>
          </div>

        </div>

        <div class="tnm-sheet-footer">
          <a v-if="vm.is__adani_page" href="https://www.adanienterprises.com/" target="_blank" rel="noopener noreferrer">Adani Enterprises Ltd</a>
          <a v-else-if="vm.is__gmr_page" href="https://www.gmrgroup.in/airports/" target="_blank" rel="noopener noreferrer">GMR Airports Limited</a>
          <a v-else-if="vm.is__vardhman_page" href="https://www.vardhman.com/" target="_blank" rel="noopener noreferrer">Vardhman</a>
          <a v-else-if="vm.is__parle_page" href="https://www.parleproducts.com/" target="_blank" rel="noopener noreferrer">Parle Products</a>
          <a v-else-if="vm.is__granules_page" href="https://granulesindia.com/" target="_blank" rel="noopener noreferrer">Granules India</a>
          <a v-else-if="vm.is__emami_page" href="https://www.emamiltd.in/" target="_blank" rel="noopener noreferrer">Emami Ltd</a>
          <span v-else>{{ vm.entity_name }}</span>
        </div>
      </div>
    </transition>

    <!-- ═══ Switch Host secondary sheet (company + host lists, same data/methods as desktop) ═══ -->
    <transition name="tnm-fade">
      <div v-if="hostSheetOpen" class="tnm-sheet-backdrop" @click="hostSheetOpen = false"></div>
    </transition>
    <transition name="tnm-sheet-up">
      <div v-if="hostSheetOpen" class="tnm-sheet tnm-host-sheet">
        <div class="tnm-sheet-handle"></div>
        <div class="tnm-sheet-header">
          <span>Switch Host</span>
          <button class="tnm-sheet-close" @click="hostSheetOpen = false"><v-icon size="18">mdi-close</v-icon></button>
        </div>
        <div class="tnm-sheet-body tnm-host-body">
          <template v-if="vm.has_company_data && vm.company_dataset && vm.company_dataset.length > 0">
            <div class="tnm-host-section-lb">Select Company</div>
            <div v-for="company in vm.company_dataset" :key="'m-company-' + company.id" class="tnm-host-row"
              :class="{ on: vm.company_id === company.id }" @click="vm.selectCompany(company)">
              <v-icon size="19" :color="vm.company_id === company.id ? '#4CAF50' : '#7E8299'">{{ vm.company_id === company.id ? 'mdi-office-building' : 'mdi-office-building-outline' }}</v-icon>
              <span class="tnm-host-name">{{ company.name }}</span>
              <v-icon v-if="vm.company_id === company.id" size="17" color="#4CAF50">mdi-check-circle</v-icon>
            </div>
          </template>
          <div class="tnm-host-section-lb">Select Host</div>
          <div v-for="h in visibleHosts" :key="'m-host-' + h.key" class="tnm-host-row" :class="{ on: vm.isCurrentHost(h.key) }"
            :style="{ borderLeftColor: vm.isCurrentHost(h.key) ? h.solid : 'transparent' }" @click="act(() => vm.switchToHost(h.key))">
            <v-icon size="19" :color="vm.isCurrentHost(h.key) ? h.solid : '#7E8299'">{{ vm.isCurrentHost(h.key) ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
            <div class="tnm-host-name-wrap">
              <span class="tnm-host-name" :style="vm.isCurrentHost(h.key) ? { color: h.solid, fontWeight: 700 } : {}">{{ h.label }}</span>
              <span class="tnm-host-sub">{{ h.subtitle }}</span>
            </div>
            <v-icon size="18" :color="vm.user_favourite && vm.user_favourite.toUpperCase() === h.favKey ? h.solid : '#B5B5C3'"
              @click.stop="vm.setFavouriteHost(h.favKey)">{{ vm.user_favourite && vm.user_favourite.toUpperCase() === h.favKey ? 'mdi-heart' : 'mdi-heart-outline' }}</v-icon>
            <v-icon v-if="vm.isCurrentHost(h.key)" size="17" :color="h.solid">mdi-check-circle</v-icon>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import QuickAccessPanel from "@/components/Menu/QuickAccessPanel.vue";

export default {
  name: 'TopNavBarMobile',
  components: { QuickAccessPanel },
  props: { vm: { type: Object, required: true } },
  data() {
    return {
      sheetOpen: false,
      hostSheetOpen: false,
      hosts: [
        { key: 'starr', flag: 'entity_starr_flag', label: 'Starr', subtitle: 'Compliance', solid: '#9C27B0', favKey: 'STARR' },
        { key: 'board', flag: 'entity_board_flag', label: 'Board', subtitle: 'Board Page', solid: '#FF5722', favKey: 'BOARD' },
        { key: 'familybook', flag: 'entity_family_book_flag', label: 'Familybook', subtitle: 'Family Tree', solid: '#5782C7', favKey: 'FAMILYBOOK' },
      ],
    }
  },
  computed: {
    visibleHosts() {
      return this.hosts.filter(h => this.vm[h.flag])
    },
  },
  watch: {
    'vm.$route'() { this.sheetOpen = false; this.hostSheetOpen = false },
  },
  methods: {
    act(fn) {
      this.sheetOpen = false
      fn()
    },
  },
}
</script>

<style scoped>
.tnm-root >>> .tnm-bar.v-app-bar { box-shadow: 0px 4.5px 11.24px 0px #091E421A !important; height: 56px !important; }
.tnm-root >>> .tnm-bar .v-toolbar__content { height: 56px !important; padding: 0 8px !important; }

.tnm-hamburger { width: 40px; height: 40px; border-radius: 10px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; cursor: pointer; background: linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%); }
.tnm-logo { display: flex; align-items: center; margin-left: 8px; min-width: 0; }
.tnm-logo-img { height: 26px; width: auto; max-width: 90px; object-fit: contain; }

.tnm-chat-btn { position: relative; width: 32px; height: 32px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; background: linear-gradient(135deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%); margin-right: 6px; flex-shrink: 0; }
.tnm-chat-dot { position: absolute; top: 1px; right: 1px; width: 8px; height: 8px; background: #22c55e; border: 2px solid #fff; border-radius: 50%; }
.tnm-chat-badge { position: absolute; top: -4px; right: -4px; min-width: 15px; height: 15px; padding: 0 3px; background: #ef4444; color: #fff; font-size: 9px; font-weight: 700; line-height: 15px; text-align: center; border-radius: 8px; border: 2px solid #fff; box-sizing: content-box; }

.tnm-profile-img { width: 32px; height: 32px; border-radius: 8px; cursor: pointer; flex-shrink: 0; object-fit: cover; margin-left: 6px; }

.tnm-qa-trigger { width: 34px; height: 34px; border-radius: 10px; border: none; margin-left: 6px; flex-shrink: 0; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; background: linear-gradient(135deg, #6366F1 0%, #8B5CF6 50%, #A855F7 100%); }
.tnm-qa-trigger:active { transform: scale(.92); }

.tnm-sheet-backdrop { position: fixed; inset: 0; background: rgba(26,26,46,.4); z-index: 2400; }
.tnm-sheet { position: fixed; left: 0; right: 0; bottom: 0; z-index: 2401; background: #fff; border-radius: 18px 18px 0 0; max-height: 78vh; display: flex; flex-direction: column; box-shadow: 0 -8px 30px rgba(0,0,0,.18); }
.tnm-sheet-handle { width: 36px; height: 4px; border-radius: 2px; background: #E4E6EF; margin: 10px auto 4px; flex-shrink: 0; }
.tnm-sheet-header { display: flex; align-items: center; justify-content: space-between; padding: 8px 18px 12px; font-size: 15px; font-weight: 700; color: #181C32; flex-shrink: 0; }
.tnm-sheet-close { background: #F5F8FA; border: none; width: 28px; height: 28px; border-radius: 8px; cursor: pointer; display: flex; align-items: center; justify-content: center; }
.tnm-sheet-body { overflow-y: auto; padding: 4px 14px 24px; display: grid; grid-template-columns: repeat(4, 1fr); gap: 14px 8px; }

.tnm-grid-item { display: flex; flex-direction: column; align-items: center; gap: 6px; cursor: pointer; position: relative; padding: 4px 2px; border-radius: 10px; transition: background .15s; }
.tnm-grid-item:active { background: #F5F8FA; }
.tnm-grid-item-wide { grid-column: 1 / -1; }
.tnm-grid-ic { width: 46px; height: 46px; border-radius: 14px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.tnm-grid-ic-plain { background: #F5F8FA; }
.tnm-grid-ic-text { font-size: 12px; font-weight: 700; color: #fff; }
.tnm-grid-label { font-size: 10px; font-weight: 600; color: #3F4254; text-align: center; line-height: 1.25; }
.tnm-grid-badge { position: absolute; top: 0; right: 4px; background: #6366F1; color: #fff; font-size: 8px; font-weight: 700; padding: 1px 5px; border-radius: 8px; }
.tnm-sheet-footer { grid-column: 1 / -1; text-align: center; padding-top: 6px; border-top: 1px solid #F0F0F5; font-size: 10.5px; color: #A1A5B7; }
.tnm-sheet-footer a { color: #5A5A72; text-decoration: underline; }

.tnm-host-sheet { max-height: 70vh; }
.tnm-host-body { display: block; padding: 0 16px 24px; }
.tnm-host-section-lb { font-size: 11px; font-weight: 700; color: #3F4254; margin: 12px 0 6px; }
.tnm-host-row { display: flex; align-items: center; gap: 12px; padding: 12px 8px; border-radius: 10px; border-left: 4px solid transparent; cursor: pointer; }
.tnm-host-row.on { background: rgba(0,0,0,.03); }
.tnm-host-name-wrap { flex: 1; min-width: 0; display: flex; flex-direction: column; }
.tnm-host-name { font-size: 13px; color: #3F4254; }
.tnm-host-sub { font-size: 10.5px; color: #A1A5B7; }

.tnm-fade-enter-active, .tnm-fade-leave-active { transition: opacity .2s ease; }
.tnm-fade-enter, .tnm-fade-leave-to { opacity: 0; }
.tnm-sheet-up-enter-active, .tnm-sheet-up-leave-active { transition: transform .25s cubic-bezier(.22,1,.36,1), opacity .2s ease; }
.tnm-sheet-up-enter, .tnm-sheet-up-leave-to { transform: translateY(100%); opacity: .5; }

.app_z_index { z-index: 500 !important; }

.sub_list_txt { font-weight: 400; font-size: 12px; color: #3F4254; }
.tnm-host-row.on .tnm-host-name { font-weight: 600; }

/* Reuse the Quick Access panel as-is, presented full-screen on mobile */
.tnm-grid-item-wide >>> .qa-wrapper { width: 100%; }
.tnm-grid-item-wide >>> .qa-trigger-btn { width: 100%; height: 40px !important; justify-content: center; }
.tnm-grid-item-wide >>> .qa-dropdown { position: fixed !important; inset: 0 !important; top: auto !important; bottom: 0 !important; width: 100% !important; max-width: 100% !important; max-height: 85vh !important; border-radius: 18px 18px 0 0 !important; z-index: 2500 !important; }
</style>
